class PageEditorActions {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/page-editor-actions`;

  }

  duplicateNodeToPages(data) {

    const path = `${this.basePath}/duplicate-node-in-pages`;

    return this.apiClient.post(path, {}, {}, data);

  }

  insertSynchronizedPageNodeInPages(data) {

    const path = `${this.basePath}/insert-synchronized-page-node-in-pages`;

    return this.apiClient.post(path, {}, {}, data);

  }

}

export default PageEditorActions;